import CardLocation from '@alltrails/amplitude/enums/CardLocation';
import { LocationDetailsResponseType } from '@/types/locationDetailsPages/shared';

export const getAnalyticsCardLocation = (type?: LocationDetailsResponseType, location?: 'map' | 'list'): CardLocation | undefined => {
  switch (type) {
    case 'poi':
      return 'poi page';
    case 'park':
      return 'park page';
    default:
      if (location === 'map') {
        return 'location page map';
      } else if (location === 'list') {
        return 'location page list';
      } else {
        return 'location page';
      }
  }
};
